export default "__VITE_ASSET__9f296d18__"